export default import.meta.ROLLUP_FILE_URL_JZB8cIvYl6xptx0YqViHjA